import { useCallback, useEffect, useMemo } from 'react';
import { ApiService } from '../services/api-services/ApiService';
import socketClusterService from '../services/unifiedSocketService';
import { StorageUtils } from '../utils/StorageUtils';

// Hook minimal pour synchroniser le JWT avec Socket.IO
// et obtenir un socketToken court via /api/sessions/socket.
// Utilisation:
//  - Global (boot): const { issueSocketToken } = useSocketAuth();
//  - Téléconsultation: const { issueSocketToken } = useSocketAuth(); await issueSocketToken(sessionToken);
export default function useSocketAuth() {
  const api = useMemo(() => ApiService.getInstance(), []);

  // Propager le JWT stocké vers la socket au montage
  useEffect(() => {
    try {
      const jwt = StorageUtils.getToken();
      if (jwt) socketClusterService.setAuthToken(jwt);
    } catch {
      // ignore
    }
  }, []);

  // Génère un token socket court à partir d'un sessionToken
  const issueSocketToken = useCallback(async (sessionToken: string) => {
    const resp = await api.post<{ socketToken: string; expiresAt: number }>(
      '/api/sessions/socket',
      { sessionToken }
    );

    // Met à jour l'auth de la socket avec JWT + socketToken
    try {
      const jwt = StorageUtils.getToken();
      socketClusterService.setSocketCredentials(jwt || '', resp.socketToken);
    } catch {
      // ignore
    }

    return resp;
  }, [api]);

  return { issueSocketToken };
}
